import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DistrictPortabilityReport = ({ month, year, heading, onDrillDown }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_URL}/api/report/districts?month=${month}&year=${year}`)
      .then(res => {
        setData(res.data.data || []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        alert('Error loading district data');
        setLoading(false);
      });
  }, [month, year]);

  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  const monthName = monthNames[parseInt(month) - 1] || '';

  if (loading) return <div>Loading District Report...</div>;
  if (!loading && data.length === 0) {
    return <div align="center" className="response">No data found.</div>;
  }


  const firstRow = data[0];
  const commodities = Object.keys(firstRow.percent_port_per_commodity || {});

  // Calculate totals
  const totals = data.reduce((acc, item) => {
    const info = item.districtInfo || {};
    acc.totalShops += info.total_shops || 0;
    acc.portShops += info.port_shops || 0;
    acc.totalCards += info.total_cards || 0;
    acc.saleCards += info.total_sale_rc || 0;
    acc.portCards += info.total_port_rc || 0;
    //acc.inRc += info.in_rc || 0;
    acc.outRc += info.out_rc || 0;
    acc.impdsRc += info.impds_rc || 0;

    // Initialize commodity objects if not exist
    if (!acc.saleQty) acc.saleQty = {};
    if (!acc.portQty) acc.portQty = {};

    commodities.forEach(comm => {
      acc.saleQty[comm] = (acc.saleQty[comm] || 0) + (item.salecommodities_qty[`sale_${comm}`] || 0);
      acc.portQty[comm] = (acc.portQty[comm] || 0) + (item.portcommodities_qty[`port_${comm}`] || 0);
    });

    return acc;
  }, {
    totalShops: 0,
    portShops: 0,
    totalCards: 0,
    saleCards: 0,
    portCards: 0,
    //inRc: 0,
    outRc: 0,
    impdsRc: 0,
    saleQty: {},
    portQty: {}
  });

  // Calculate percentages
  totals.portShopsPct = totals.totalShops > 0 ? (totals.portShops / totals.totalShops * 100).toFixed(2) : '0.00';
  totals.saleCardsPct = totals.totalCards > 0 ? (totals.saleCards / totals.totalCards * 100).toFixed(2) : '0.00';
  totals.portCardsPct = totals.saleCards > 0 ? (totals.portCards / totals.saleCards * 100).toFixed(2) : '0.00';

  // Overall commodity % (total port / total sale)
  totals.portPct = {};
  commodities.forEach(comm => {
    const sale = totals.saleQty[comm] || 0;
    const port = totals.portQty[comm] || 0;
    totals.portPct[comm] = sale > 0 ? (port / sale * 100).toFixed(2) : '0.00';
  });

  return (
    <div>
      <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead style={{ position: 'sticky', top: 0, backgroundColor: '#000', zIndex: 1 }}>
          {/* Main Heading */}
          <tr>
            <th colSpan={13 + commodities.length * 3} className='tableheader'>
              {heading} - {monthName} / {year}
            </th>
          </tr>

          <tr className="tableheader">
            <th rowSpan="2">S.No</th>
            <th rowSpan="2">District</th>
            <th rowSpan="2">Total Shops</th>
            <th rowSpan="2">Portability Shops</th>
            <th rowSpan="2">Portability Shops %</th>
            <th rowSpan="2">Total Cards</th>
            <th rowSpan="2">Sale Cards</th>
            <th rowSpan="2">% of Total Sale Cards</th>
            <th rowSpan="2">Portability Sale Cards</th>
            <th rowSpan="2">Portability Cards %</th>
            <th colSpan="3">Sale Cards</th>
            {/* <th rowSpan="2">In RC</th>
            <th rowSpan="2">Out RC</th>
            <th rowSpan="2">IMPDS RC</th> */}
            <th colSpan={commodities.length}>Total Sale Qty (Kg)</th>
            <th colSpan={commodities.length}>Portability Sale Qty (Kg)</th>
            <th colSpan={commodities.length}>Portability Sale %</th>
          </tr>
          <tr className="tableheader" style={{ backgroundColor: '#444' }}>
            <th>In </th>
            <th>Out </th>
            <th>IMPDS </th>

            {/* Commodity Sub-headers */}
            {commodities.map(comm => <th key={comm}>{comm.replace(/_/g, ' ').toUpperCase()}</th>)}
            {commodities.map(comm => <th key={`port_${comm}`}>{comm.replace(/_/g, ' ').toUpperCase()}</th>)}
            {commodities.map(comm => <th key={`pct_${comm}`}>{comm.replace(/_/g, ' ').toUpperCase()}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => {
            const info = item.districtInfo;
            return (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td align="left">
                  {onDrillDown ? (
                    <a href="#" onClick={(e) => { e.preventDefault(); onDrillDown(info.dist_name_en); }} style={{ color: 'black', textDecoration: 'underline' }}>
                      {info.dist_name_en}
                    </a>
                  ) : info.dist_name_en}
                </td>
                <td align="right">{info.total_shops}</td>
                <td align="right">{info.port_shops}</td>
                <td align="right">{info.port_shops_pct?.toFixed(2)}</td>
                <td>{info.total_cards}</td>
                <td align="right">{info.total_sale_rc}</td>
                <td align="right">{((info.total_sale_rc / info.total_cards) * 100).toFixed(2)}</td>
                <td align="right">{info.total_port_rc}</td>
                <td align="right">{info.percent_port_against_sale?.toFixed(2)}</td>
                <td align="right">{info.total_port_rc || 0}</td>
                <td align="right">{info.out_rc || 0}</td>
                <td align="right">{info.impds_rc || 0}</td>
                {commodities.map(comm => (
                  <td align="right" key={comm}>{item.salecommodities_qty[`sale_${comm}`]?.toFixed(2) || 0}</td>
                ))}
                {commodities.map(comm => (
                  <td align="right" key={`port_${comm}`}>{item.portcommodities_qty[`port_${comm}`]?.toFixed(2) || 0}</td>
                ))}
                {commodities.map(comm => (
                  <td align="right" key={`pct_${comm}`}>{item.percent_port_per_commodity[comm]?.toFixed(2)}</td>
                ))}
              </tr>
            );
          })}


          <tr className='tableheader'>
            <td align="right" colSpan="2">TOTAL</td>
            <td align="right">{totals.totalShops}</td>
            <td align="right">{totals.portShops}</td>
            <td align="right">{totals.portShopsPct}</td>
            <td align="right">{totals.totalCards}</td>
            <td align="right">{totals.saleCards}</td>
            <td align="right">{totals.saleCardsPct}</td>
            <td align="right">{totals.portCards}</td>
            <td align="right">{totals.portCardsPct}</td>
            <td align="right">{totals.portCards}</td>
            <td align="right">{totals.outRc}</td>
            <td align="right">{totals.impdsRc}</td>

            {/* Sale Qty totals */}
            {commodities.map(comm => (
              <td align="right" key={comm}>{totals.saleQty[comm]?.toFixed(2) || '0.00'}</td>
            ))}

            {/* Port Qty totals */}
            {commodities.map(comm => (
              <td align="right" key={`port_${comm}`}>{totals.portQty[comm]?.toFixed(2) || '0.00'}</td>
            ))}

            {/* Port % totals */}
            {commodities.map(comm => (
              <td align="right" key={`pct_${comm}`}>{totals.portPct[comm]}</td>
            ))}
          </tr>
        </tbody>
      </table>
      <br /><br /><br /><br />
    </div>
  );
};

export default DistrictPortabilityReport;